module.exports = __webpack_public_path__ + "static/media/calendrier_2019_FR.b828812a.png";